import './ListSupplementItem.scss'

import React from 'react'

import { useSupplement, ProductService } from 'hb4e-ui-product'
import { Icon, Modal } from 'hb4e-ui-core-ui'
import { KalturaVideoPlayer, KalturaVideoPlayerNew } from 'hb4e-ui-vendor'
import { useFeatureFlags } from 'hb4e-ui-env-config'

import { getProductDetailsForListItem } from '../../../../../../../../list-service'

const { getProductTitle } = ProductService

const ListSupplementItem = ({ supplement, item }) => {
  const { isExpired } = getProductDetailsForListItem(item)
  const supplementTitle = getProductTitle(supplement)
  const { supplementID, openSupplement, getSupplementIcon, isSupplementModalOpen, closeSupplementModal, videoID } =
    useSupplement(supplement)

  // TODO: AH (10/03/2024) - Remove FF during heet-653-kaltura-player-upgrade clean up.
  const { heet653KalturaPlayerUpgrade } = useFeatureFlags()

  const isExpiredClass = isExpired ? 'is-product-expired' : ''

  return (
    <div className="list-supplement-item">
      <div className="list-supplement-item__product-icon-container">
        <Icon icon={getSupplementIcon()} className="list-supplement-item__product-icon" />
      </div>
      <div className="list-supplement-item__product-container">
        <div className="list-supplement-item__product-title-container">
          <button
            data-testid="open-supplement-button"
            className={`list-supplement-item__product-title ${isExpiredClass}`}
            disabled={isExpired}
            onClick={openSupplement}
          >
            {supplementTitle}
          </button>
        </div>
        <div className="list-supplement-item__product-number-container">
          <span className="list-supplement-item__product-number">{`Product #: ${supplementID}`}</span>
        </div>
      </div>
      <Modal title={supplementTitle} isOpen={isSupplementModalOpen} onClose={closeSupplementModal}>
        {/* TODO: AH (10/03/2024) - Remove FF during heet-653-kaltura-player-upgrade clean up. */}
        {heet653KalturaPlayerUpgrade ? (
          <KalturaVideoPlayerNew contentID={videoID} />
        ) : (
          <KalturaVideoPlayer contentID={videoID} />
        )}
      </Modal>
    </div>
  )
}

export default ListSupplementItem
